import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Level1Content from '../../../components/program/criteria/Level1Content';
import useAxios from '../../../hooks/useAxios';
import {
  IEvaluationItem,
  IEvaluationItemBody,
  IEvaluationItemCreate,
  IGetEvaluationItem,
} from '../../../models/evaluationItem.model';
import {
  getEvaluationItem,
  postEvaluationItem,
  putEvaluationItem,
} from '../../../api/evaluationItem.api';
import useNotification from '../../../hooks/useNotification';
import Level2Content from '../../../components/program/criteria/Level2Content';
import { IGetTypes } from '../../../models/evaluation.model';
import { getTypes } from '../../../api/evaluation.api';
import { IGetSubjects } from '../../../models/subject.model';
import { getSubjects } from '../../../api/subject.api';
import useLoader from '../../../hooks/useLoader';
import Split from 'react-split';

const ProgramCriteria: FC = () => {
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvaluationItem>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetTypes>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetSubjects>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetEvaluationItem>();
  const { data: postRes, isLoading: postIsLoading, error: postError,
    execute: postExecute } = useAxios();
  const { data: putRes, isLoading: putIsLoading, error: putError, execute: putExecute } = useAxios();
  useLoader(
    isLoading || isLoading2 || isLoading3 || isLoading4 || postIsLoading || putIsLoading,
    [error, error2, error3, error4, postError, putError],
  );

  const [level1ContentData, setLevel1ContentData] = useState<IEvaluationItem[]>([]);
  const [level2ContentData, setLevel2ContentData] = useState<IEvaluationItem[]>([]);
  const [evaluationItemParentCode, setEvaluationItemParentCode] = useState<number>();

  useEffect(() => {
    execute(getEvaluationItem());
    execute2(getTypes());
    execute3(getSubjects());
  }, []);

  useEffect(() => {
    setLevel1ContentData(res?.data ?? []);
  }, [res]);

  useEffect(() => {
    setLevel2ContentData(res4?.data ?? []);
  }, [res4]);

  useEffect(() => {
    if (postRes) {
      successNotification(t('common.message.create1'));
      execute(getEvaluationItem());
      evaluationItemParentCode &&
        execute4(getEvaluationItem({ evaluationItemParentCode }));
    }
  }, [postRes]);

  useEffect(() => {
    if (putRes) {
      successNotification(t('common.message.save1'));
      execute(getEvaluationItem());
      evaluationItemParentCode &&
        execute4(getEvaluationItem({ evaluationItemParentCode }));
    }
  }, [putRes]);

  const onLevel1Create = (body: IEvaluationItemCreate) => {
    postExecute(postEvaluationItem(body));
  };

  const onLevel2Create = (body: IEvaluationItemCreate) => {
    postExecute(postEvaluationItem({ ...body, evaluationItemParentCode }));
  };

  const onUpdate = (evaluationItemCode: number, body: IEvaluationItemBody) => {
    if (!body.evaluationItemName)
      return infoNotification(t('program.criteria.message1'));
    putExecute(putEvaluationItem(evaluationItemCode, body));
  };

  const getLevel2ContentData = (evaluationItemCode: number) => {
    setEvaluationItemParentCode(evaluationItemCode);
    execute4(
      getEvaluationItem({ evaluationItemParentCode: evaluationItemCode }),
    );
  };

  return (
    <>
    <div className="content">
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.criteria.title1')}
        iconFile="icon-program-big.svg"
        onlyTitle={true}
      />
      <Split 
        className='splite-divide'
        sizes={[35, 65]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className='col-frame left_panel'>
          <Level1Content
            data={level1ContentData}
            onCreate={onLevel1Create}
            onUpdate={onUpdate}
            onRowClick={getLevel2ContentData}
            evaluationItemParentCode={evaluationItemParentCode}
          />
        </div>
        <div className='col-frame right_panel'>
          <Level2Content
            data={level2ContentData}
            types={res2?.data ?? []}
            subjects={res3?.data ?? []}
            onUpdate={onUpdate}
            onCreate={onLevel2Create}
          />
        </div>
      </Split>
    </div>
    </>
  );
};

export default ProgramCriteria;